import "./PowerBiDashboard.scss";
import { PowerBiIcon } from "../../../icons";

function PowerBiDashboard() {
  return (
    <div className="powerbi-dashboard">
      <div className="powerbi-placeholder">
        <div className="powerbi-placeholder__icon">
          <PowerBiIcon />
        </div>
        <h2 className="powerbi-placeholder__title">Power BI Dashboard</h2>
        <p className="powerbi-placeholder__message">
          Dashboards coming soon...
        </p>
        <p className="powerbi-placeholder__sub">
          We are working on integrating Power BI dashboards. Stay tuned!
        </p>
      </div>
    </div>
  );
}

export default PowerBiDashboard;
